module.exports = __webpack_public_path__ + "img/shrewd-save-4.f0153970.jpg";